import React from 'react';
import '../custom.scss';

const HRTag = ({title}) => {
    return (
        <hr className="hr-text" data-content={title} />          
    );
};

export default HRTag;
